var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ApartmentTypeService } from './../api/apartment-type.service';
import { AgencyService } from './../api/agency.service';
import { OnInit, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Lightbox, LightboxConfig, LightboxEvent, LIGHTBOX_EVENT } from 'angular2-lightbox';
import { BaseComponent } from './base-component';
import { GoogleMapComponent } from '../gmaps/google-map/google-map.component';
import { FbqService } from '../analytics/fbq.service';
var ApartmentTypeDetailsBaseComponent = /** @class */ (function (_super) {
    __extends(ApartmentTypeDetailsBaseComponent, _super);
    function ApartmentTypeDetailsBaseComponent(injector, route, agencyService, apartmentTypeService, _lightbox, _lightboxEvent, _lighboxConfig, window, document) {
        var _this = _super.call(this, injector) || this;
        _this.route = route;
        _this.agencyService = agencyService;
        _this.apartmentTypeService = apartmentTypeService;
        _this._lightbox = _lightbox;
        _this._lightboxEvent = _lightboxEvent;
        _this._lighboxConfig = _lighboxConfig;
        _this.window = window;
        _this.document = document;
        _this.fbqService = injector.get(FbqService);
        return _this;
    }
    ApartmentTypeDetailsBaseComponent.prototype.notifyFb = function () {
        this.fbqService.sendEvent('ViewContent', {
            content_name: 'ApartmentType',
            content_id: [this.apartmentType.type_name]
        });
    };
    ApartmentTypeDetailsBaseComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.data.forEach(function (data) {
            if (data.apartment_type) {
                _this.validateRouteDataParams(data, ['apartment_type']);
                _this.apartmentType = data.apartment_type;
                _this.item = data.apartment_type;
                _this.item.latitude = _this.agencyService.agency.latitude;
                _this.item.longitude = _this.agencyService.agency.longitude;
                _this.initLightbox(_this.apartmentType.images);
                _this.setTitle(_this.apartmentType.title);
                _this.setMetaDescription(_this.apartmentType.description);
                _this.notifyFb();
            }
        });
    };
    ApartmentTypeDetailsBaseComponent.prototype.open = function (index) {
        var _this = this;
        if (this.window) {
            this._lighboxConfig.positionFromTop = 0;
            this._lighboxConfig.centerVertically = true;
            this._lighboxConfig.fitImageInViewPort = true;
        }
        this._subscription = this._lightboxEvent.lightboxEvent$.subscribe(function (event) { return _this._onReceivedEvent(event); });
        this._lightbox.open(this._albums, index, { wrapAround: true, showImageNumberLabel: true });
    };
    ApartmentTypeDetailsBaseComponent.prototype._onReceivedEvent = function (event) {
        if (event.id === LIGHTBOX_EVENT.CLOSE) {
            if (this._subscription) {
                this._subscription.unsubscribe();
            }
        }
    };
    ApartmentTypeDetailsBaseComponent.prototype.initLightbox = function (images) {
        this._albums = [];
        for (var _i = 0, images_1 = images; _i < images_1.length; _i++) {
            var image = images_1[_i];
            var album = {
                src: image.url,
                caption: image.description,
                thumb: image.width_560_url
            };
            this._albums.push(album);
        }
        this._lighboxConfig.fadeDuration = 1;
    };
    return ApartmentTypeDetailsBaseComponent;
}(BaseComponent));
export { ApartmentTypeDetailsBaseComponent };



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/apartment-type-details-base.component.ts.pre-build-optimizer.js